module.exports = "/_next/static/images/most_volatility-d40166ef7e4469a2bd724f0f5e17c970.svg";